var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAxionSpinnyCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 574.29 571.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.35;}.cls-2{fill:#f76800;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.41,133.75a166,166,0,1,0,166,166A166,166,0,0,0,298.41,133.75Zm0,329.19A163.19,163.19,0,1,1,461.59,299.75,163.19,163.19,0,0,1,298.41,462.94Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.2,345.76c-3.4,1.17-6.81,2.31-10.25,3.39A143.56,143.56,0,0,0,212,414.07c1-1.65,2.06-3.27,3-4.95.83-1.45,1.61-2.93,2.42-4.4A132.75,132.75,0,0,1,174.2,345.76Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.84,272.18a132.83,132.83,0,0,1,86-97.76q-1.81-5.07-3.64-10.14a143.69,143.69,0,0,0-93,106C161.73,271,165.28,271.6,168.84,272.18Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.43,417c-1.44,3.29-2.9,6.57-4.41,9.84a144,144,0,0,0,20.23,8.69c1-3.44,2.09-6.87,3.16-10.29A131.89,131.89,0,0,1,236.43,417Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M421.21,350.6a133,133,0,0,1-79.07,74.49c1.17,3.43,2.38,6.85,3.59,10.27a144,144,0,0,0,85.42-80.6Q426.08,352.9,421.21,350.6Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M442.12,298.87a142.77,142.77,0,0,0-31-88.12c-2.72,2.36-5.49,4.67-8.25,7a132.09,132.09,0,0,1,28.43,81.15Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.58,159.61A140.14,140.14,0,1,0,438.72,299.75,140.14,140.14,0,0,0,298.58,159.61Zm0,276.31A136.17,136.17,0,1,1,434.76,299.75,136.16,136.16,0,0,1,298.58,435.92Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.58,170.25a129.5,129.5,0,1,0,129.51,129.5A129.49,129.49,0,0,0,298.58,170.25Zm0,258.14A128.64,128.64,0,1,1,427.22,299.75,128.64,128.64,0,0,1,298.58,428.39Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.41,51C161.05,51,49.69,162.39,49.69,299.75S161.05,548.47,298.41,548.47,547.13,437.12,547.13,299.75,435.77,51,298.41,51Zm0,495.77c-136.44,0-247-110.61-247-247s110.61-247,247.05-247,247.05,110.6,247.05,247S434.85,546.8,298.41,546.8Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320.37,81.3c-7.23-.72-14.54-1.13-22-1.13a219.78,219.78,0,0,0-23.79,1.37c.49,3.76,1,7.51,1.41,11.28a206.89,206.89,0,0,1,22.38-1.3A211.57,211.57,0,0,1,320,92.65C320.07,92.16,320.22,84.59,320.37,81.3Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.37,434.13a208.51,208.51,0,0,1-23.29-33.78c-3.27,1.92-6.56,3.78-9.91,5.54a220.06,220.06,0,0,0,24.64,35.69C133.54,439,136.41,436.53,139.37,434.13Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M492.18,377l-.32-.09a208,208,0,0,1-20.36,38.63c3.23,2,6.56,3.76,9.88,5.57a219.74,219.74,0,0,0,20.8-39.62C501.52,381.19,494.79,378.3,492.18,377Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.16,293.22c.05-.91.09-1.82.16-2.72l-5.83-.48c-.07.91-.12,1.82-.17,2.73Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.08,308.54c0-.91-.07-1.83-.1-2.73l-5.86.12c0,.91.07,1.82.1,2.73Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.75,232.5c.41-.8.89-1.59,1.32-2.39l-5.15-2.79c-.44.8-.9,1.58-1.31,2.39Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.19,262.14c.23-.88.46-1.76.73-2.63l-5.62-1.67c-.26.88-.49,1.76-.73,2.64Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.93,277.11c.15-.9.26-1.8.43-2.7l-5.76-1.09c-.16.9-.28,1.8-.43,2.7Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.39,246.44c.33-.84.71-1.68,1.06-2.52l-5.4-2.25c-.35.84-.74,1.67-1.07,2.51Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.68,324.81c-.14-.9-.23-1.81-.35-2.71l-5.81.75c.12.91.22,1.82.36,2.71Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.93,395.74c-.57-.72-1.12-1.44-1.69-2.15l-4.65,3.54c.55.72,1.11,1.44,1.68,2.15Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,383.3c-.49-.76-1-1.53-1.46-2.3l-5,3.05c.48.77,1,1.55,1.46,2.31Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.22,408.32c-.65-.65-1.26-1.32-1.89-2l-4.24,4c.64.65,1.24,1.32,1.89,2Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163,369.3c-.4-.82-.83-1.62-1.23-2.44l-5.3,2.49c.39.83.82,1.63,1.24,2.45Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.82,339.8c-.23-.88-.44-1.76-.65-2.64l-5.71,1.34c.22.88.42,1.77.65,2.65Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.63,418.54c-.7-.57-1.38-1.18-2.07-1.76l-3.81,4.46c.7.58,1.37,1.19,2.08,1.77Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.79,355.27c-.32-.85-.68-1.69-1-2.54l-5.52,1.94c.31.86.66,1.7,1,2.55Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.53,153.42c.9.18,1.79.41,2.68.61l1.17-5.74c-.89-.2-1.77-.43-2.66-.61Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.38,151.12c.9.09,1.8.21,2.71.31l.59-5.83c-.91-.1-1.81-.22-2.72-.31Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M343.51,157.66c.87.28,1.74.58,2.6.87L347.9,153c-.86-.3-1.73-.6-2.59-.88Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.85,163.14c.83.37,1.66.74,2.49,1.13l2.35-5.36c-.83-.39-1.66-.77-2.49-1.13Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M375.41,165.53l-2.92,5.09c.79.45,1.59.89,2.38,1.37l2.9-5.09C377,166.43,376.19,166,375.41,165.53Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296,150.39c.91,0,1.82,0,2.73,0l0-5.85c-.91,0-1.82,0-2.73,0Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.49,171.39c.78-.47,1.56-.95,2.35-1.4l-3-5.07c-.79.45-1.56.94-2.34,1.4Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264.32,154c.9-.2,1.78-.38,2.68-.55l-1.25-5.73c-.9.18-1.78.36-2.68.56Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.92,190.52c.66-.61,1.33-1.23,2-1.84L193,184.34c-.67.6-1.34,1.22-2,1.84Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.65,180.67c.72-.54,1.45-1.09,2.19-1.63l-3.47-4.72c-.73.53-1.46,1.09-2.18,1.64Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.06,164.25c.82-.38,1.65-.77,2.48-1.13l-2.4-5.34c-.84.37-1.67.75-2.49,1.13Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.54,158.1c.87-.29,1.75-.54,2.62-.81l-1.83-5.57c-.87.27-1.74.52-2.6.81Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.74,151.29c.9-.1,1.8-.21,2.72-.29l-.63-5.82c-.91.08-1.82.19-2.72.29Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.67,316.82c-.1.9-.24,1.8-.35,2.7l5.83.59c.12-.9.25-1.79.35-2.7Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.72,285.59c.1.91.2,1.81.28,2.72l5.84-.63c-.08-.91-.2-1.81-.3-2.72Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.2,332.19c-.2.89-.41,1.77-.62,2.66l5.73,1.21c.2-.89.42-1.77.62-2.66Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.52,301.48c0,.91,0,1.82-.07,2.73h5.87c0-.9,0-1.82.05-2.72Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M440.21,347c-.28.86-.58,1.72-.88,2.58l5.58,1.79c.3-.87.6-1.73.87-2.59Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M427.61,375.39c-.46.8-.9,1.59-1.37,2.37l5.08,2.91c.47-.79.92-1.58,1.37-2.37Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.57,361.71c-.36.83-.74,1.66-1.13,2.49l5.36,2.36c.39-.82.76-1.65,1.13-2.48Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408.69,199.88c.61.67,1.25,1.33,1.85,2l4.32-3.95c-.6-.69-1.24-1.34-1.85-2Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397.81,189.05c.68.61,1.38,1.2,2.05,1.82l3.89-4.38c-.67-.61-1.36-1.21-2-1.81Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.36,179c.74.54,1.48,1.05,2.21,1.6l3.41-4.76c-.73-.55-1.47-1.06-2.21-1.6Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.4,270.41c.18.9.39,1.78.56,2.68l5.72-1.22c-.16-.9-.37-1.78-.55-2.68Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M419.46,213.19c.54.74,1,1.5,1.56,2.25l4.74-3.45c-.52-.75-1-1.5-1.55-2.25Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M440.36,254.92c.28.87.54,1.73.81,2.61l5.56-1.82c-.26-.88-.53-1.75-.8-2.62Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M360.2,437.18c-.82.38-1.64.76-2.48,1.12l2.4,5.34,2.5-1.12Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.87,450c-.89-.15-1.79-.26-2.69-.43l-1.06,5.77c.9.16,1.8.27,2.7.42Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.5,446.7l-2.63-.73-1.67,5.61c.88.26,1.76.5,2.63.74Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.58,449.86l-2.71.3.62,5.82c.91-.09,1.81-.18,2.71-.3Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M419.11,388.55c-.52.74-1.05,1.48-1.59,2.21l4.74,3.43c.54-.73,1.07-1.47,1.6-2.2Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.51,435.42c-.81-.42-1.61-.87-2.41-1.3l-2.8,5.14c.81.44,1.6.89,2.41,1.31Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.93,441.9l-2.53-1-2.23,5.41,2.53,1Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331,447.17c-.89.21-1.78.37-2.67.56l1.25,5.72c.88-.19,1.78-.35,2.67-.56Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M386.78,421.4c-.73.54-1.45,1.11-2.19,1.63l3.47,4.73c.74-.53,1.46-1.1,2.19-1.64Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M398.62,411.62c-.67.62-1.33,1.24-2,1.84l3.94,4.35c.67-.6,1.34-1.24,2-1.85Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M409.52,400.54c-.61.68-1.21,1.37-1.82,2l4.37,3.9c.62-.67,1.22-1.36,1.82-2Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.25,427.71c-.76-.49-1.5-1-2.25-1.54L209.69,431c.75.51,1.49,1.05,2.25,1.55Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.73,443c-.86.3-1.74.56-2.6.84l1.82,5.56c.87-.28,1.74-.54,2.6-.83Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.79,430c-.78.46-1.55.94-2.34,1.39l2.94,5.07c.79-.45,1.56-.93,2.35-1.4Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260,131.37C254.61,109.45,249.37,88,244.5,68c6.08-1.39,12.29-2.56,18.54-3.48,2.42,20.71,5,42.72,7.65,64.75C267.14,129.88,263.57,130.57,260,131.37Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.91,136.47c-7.9-21.19-15.59-41.88-22.74-61.15,5.06-1.77,10.29-3.4,15.59-4.86,4.93,20.28,10.21,41.83,15.5,63.39C247.4,134.67,244.6,135.54,241.91,136.47Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.58,144.47c-10.41-20-20.57-39.65-30-57.89,5.63-2.79,11.4-5.37,17.21-7.68,7.24,19.55,15,40.33,22.72,61.13C229.14,141.41,225.82,142.89,222.58,144.47Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.23,266.5c.89-6.24,2-12.48,3.4-18.61l63.29,15.7c-.77,3.57-1.43,7.18-2,10.78Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M332.48,130.58c-2.78-.56-5.64-1.06-8.51-1.49l7.95-64.7c5.35.76,10.7,1.71,15.94,2.82Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.66,212.16c2.33-5.82,4.9-11.61,7.68-17.25l57.8,30.17c-1.56,3.26-3,6.6-4.42,10Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.37,102.33c5.92-4,12.06-7.72,18.29-11.14,9.56,18.52,19.76,38.2,30,57.9-3.74,2.1-7.46,4.37-11.12,6.8Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68,238.12c1.49-5.52,3.21-11.07,5.14-16.57l61.07,22.93c-1.06,3.13-2,6.26-2.89,9.34Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.76,136c-3.48-1.16-7-2.21-10.49-3.13l15.38-63.36c6.16,1.58,12.23,3.4,18.11,5.42Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.43,119.87c4.71-4.07,9.65-8,14.74-11.74l37.17,53.56c-2.89,2.17-5.73,4.45-8.5,6.81Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89,186c3.21-5.88,6.63-11.55,10.18-16.93l53.68,37c-2.11,3.26-4.14,6.63-6.06,10.07Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.15,138.43c3.74-4,7.7-8,11.8-11.86l43.43,48.66c-2.29,2.18-4.43,4.33-6.47,6.5Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.68,253.16c-1-3.6-2.13-7.15-3.35-10.62l60.92-23.24c2.19,6,4.13,12.15,5.78,18.2Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M469.23,274.37c-.59-3.85-1.29-7.68-2.12-11.46l63.3-15.64c1.43,6.29,2.62,12.74,3.53,19.23Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M423,180.39c-2.56-2.65-5.2-5.24-7.89-7.71l43-49c4.76,4.3,9.3,8.75,13.56,13.28Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M417,426c2.24-2.12,4.45-4.34,6.61-6.61l48.84,43.26c-3.85,4.12-7.88,8.15-12,12Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.4,475.24c-4.68-4.31-9.2-8.85-13.51-13.52l48.84-43.17c2.53,2.68,5.17,5.33,7.88,7.88Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.93,144.63c-3.86-1.89-7.79-3.63-11.73-5.21l23-61c6.39,2.52,12.76,5.36,19,8.47Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M392.26,155c-3.1-2-6.25-3.92-9.4-5.7l30.26-57.75c5.57,3.08,11,6.36,16.21,9.8Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M407.47,166.1q-3.35-2.73-7-5.4l37.07-53.63c4.45,3.22,8.79,6.58,12.94,10Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M437.77,198c-2.56-3.5-5.27-6.92-8.08-10.2l48.68-43.37c4.57,5.29,9,10.87,13.12,16.62Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M457.68,233.19c-1.19-2.86-2.48-5.7-3.84-8.48l57.82-30.13c2.49,5,4.82,10.15,6.95,15.36Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M449.23,215.79c-1.79-3.2-3.72-6.38-5.74-9.49l53.75-37c3.42,5.2,6.71,10.68,9.81,16.32Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.89,160.82c3.67-5.09,7.58-10.06,11.64-14.83l48.75,43.28c-2.34,2.78-4.58,5.66-6.74,8.58Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.32,411.87c2.42-2.86,4.76-5.83,7-8.85L491,440c-3.77,5.2-7.76,10.26-11.92,15.12Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.67,460.42c3.49-1.43,6.95-3,10.32-4.63l30.71,57.53c-5.73,2.87-11.62,5.52-17.55,7.92Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M400.63,439.63c3-2.23,6-4.57,8.88-7l43.41,48.65c-4.85,4.14-9.93,8.14-15.13,11.92Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.53,473.24c3.85-.1,7.65-.31,11.37-.65l7.9,64.72c-6.25.62-12.58,1-18.91,1.12Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.86,471.37c3.71-.56,7.43-1.24,11.11-2l15.74,63.29c-6.19,1.39-12.54,2.55-18.94,3.46Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.72,467c3.22-.9,6.42-1.89,9.56-3l23.5,60.88c-5.7,2-11.5,3.83-17.3,5.4Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.91,451.16c3.2-1.81,6.38-3.75,9.5-5.77L429.57,499c-5.19,3.44-10.53,6.69-15.95,9.7Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M467.34,336.48q1.16-5.44,2-11.05l64.75,7.62c-.87,6.34-2,12.67-3.38,18.89Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M470.53,315.46c.27-3.16.44-6.44.54-9.92l65.2.08c-.13,5.92-.46,11.77-1,17.46Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.09,295.5c-.1-3.78-.31-7.51-.63-11.16l64.7-7.86c.63,6.32,1,12.73,1.14,19.1Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M461.58,357.26c1.25-3.61,2.4-7.29,3.42-11l63.35,15.46c-1.68,6.32-3.65,12.63-5.85,18.8Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.11,324.92c-.64-6.26-1-12.6-1.19-18.92l65.19-.29c.11,3.73.34,7.41.68,11Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.68,380.52c-2.17-6-4.08-12.14-5.7-18.16l63.33-15.66c1,3.59,2.1,7.12,3.29,10.56Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.6,406.06c-2.62-5.28-5.06-10.71-7.29-16.19l60.92-23.26c1.26,3.05,2.62,6.06,4,9Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.64,352.6c-1.32-5.86-2.41-11.79-3.27-17.71L127,326.66c.52,3.42,1.16,6.86,1.9,10.27Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.87,296c.11-6.47.5-13,1.14-19.48l64.72,7.86c-.33,3.68-.55,7.48-.65,11.33Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.26,530.41c-6.15-1.65-12.29-3.57-18.33-5.72l23.18-61c3.5,1.22,7.11,2.34,10.74,3.34Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.85,538.42c-6.42-.15-12.85-.55-19.19-1.19l7.57-64.75c3.67.35,7.44.59,11.25.71Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.7,536c-5.93-.85-11.84-1.94-17.67-3.24l15.58-63.31c3.22.69,6.45,1.29,9.66,1.79Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.43,508.61c-5.51-3.07-11-6.42-16.35-10L203,444.86q4.65,3.06,9.55,5.86Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.87,492.83c-4.77-3.48-9.44-7.15-13.93-11l43.23-48.81q3.74,3.13,7.6,6Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.56,521.05c-5.83-2.37-11.61-5-17.21-7.8l30.06-57.85c3.38,1.68,6.84,3.25,10.34,4.71Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.41,34.43c-146.54,0-265.32,118.79-265.32,265.32S151.87,565.07,298.41,565.07,563.73,446.28,563.73,299.75,444.94,34.43,298.41,34.43ZM398.16,540.8c-.65-1.76-1.29-3.53-1.92-5.28a256,256,0,0,1-160.88,11.59q-.56,2.7-1.14,5.38A261.08,261.08,0,0,1,75.36,434.4l5-1.94a255.4,255.4,0,0,1-.08-265.3c-1.5-.79-3-1.56-4.48-2.36A261.68,261.68,0,0,1,187.31,64.22c.67,1.59,1.32,3.18,2,4.78A255.26,255.26,0,0,1,428.65,80.27c.79-1.61,1.57-3.23,2.36-4.84a261.52,261.52,0,0,1,114.45,140.7c-1.74.72-3.45,1.46-5.17,2.2A255.14,255.14,0,0,1,510.66,441.5c1.73.79,3.46,1.59,5.2,2.35A261.65,261.65,0,0,1,398.16,540.8Z",
    transform: "translate(-13.11 -14.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M581.26,263c2-.43,4.09-.87,6.14-1.29a292.17,292.17,0,0,0-94.9-179.1c-1.22,1.59-2.42,3.19-3.64,4.79a285.34,285.34,0,0,0-260-64.34c-.38-1.89-.73-3.78-1.14-5.67A292.54,292.54,0,0,0,83.68,103.46l4.4,3.56A285.47,285.47,0,0,0,30.54,397.89l-5.9,1a291.86,291.86,0,0,0,148.5,164c.83-1.87,1.62-3.76,2.43-5.64a286.19,286.19,0,0,0,178.88,22.23l1,6.2A292.42,292.42,0,0,0,505.5,505c-1.75-1.22-3.47-2.47-5.19-3.71A285.17,285.17,0,0,0,581.26,263Zm-336,305C97.14,538.62.84,394.75,30.19,246.62S203.42,2.19,351.54,31.53,596,204.76,566.62,352.89,393.4,597.31,245.26,568Z",
    transform: "translate(-13.11 -14.47)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxionSpinnyCircle);
export default __webpack_public_path__ + "static/media/AxionSpinnyCircle.146577e1ff1a7212851c16c501eb561a.svg";
export { ForwardRef as ReactComponent };